import { getSkuList, getSku2Channel } from '@/api/games'
import {
  storage,
  walletIsPaying,
  walletPayingSkuId,
  firstCreatePassword,
  walletPayingOrder,
} from '@/utils/storage'
import { jsontoString } from '@/utils/tool'
import { trackClickGoPay } from '@/pages/Wallet/firebase'
import { getPriceNum, numberFormat } from '@/utils/priceFormat'
import { div } from '@/utils/accurateNumber'
import { Toast } from 'vant'
import { setRouteBase } from '@/config/routePrefix'
import { mapActions, mapMutations, mapState } from 'vuex'
import { placeOrder } from '@/api/wallet'
import { checkPasswordIsSet } from '@/api/coin'
import { deleteEmpty } from '@/api/common'
import {
  thous_separator,
  decimal_point_separator,
} from '@/utils/moneyFormatRules'
import { tryToNative } from '@/utils/native'
import bus from '@/utils/bus'
import { jumpToPage } from '@/utils/utils'
import { gameTopLupe } from '@page_detail/config'

const pageName = 'myWallet'
const gameName = gameTopLupe // 用于接口入参

// 钱包充值，目前钱包充值只会出现在游戏详情页和侧边栏的我的钱包中
export default {
  data() {
    return {
      pwIsSet: false,
      userInfo: {},
      skuList: [], // 商品列表
      channelList: [], // 支付通道列表
      selectedPaymentId: '', //当前选中的支付方式的id
      cacheChannelDatas: new Map(), //缓存sku对应的channel
      currency: '', // 货币简称，如USD
      currencySymbol: '', // 货币符号
      skuId: '', // 当前所选 skuId
      amount: 0, // 记录当前所选金额大小
      activeSku: 0, // 记录当前点击的sku的id，默认选中第一个
      isCreatingOrder: false, // 标记是否正在下单
      digit: '',
      selfDefSkuData: {}, // 自定义金额对应的sku
      errType: '',
      showPwSettingPopup: false,
      justInitiatedPw: false, // 记录是否
      // 注：是否是钱包页, 钱包页和详情页部分功能不同
      isMyWallet: this.$route.name === 'myWallet',
      loadingSkuChannels: {}, // 记录sku 对应的 sku-channel 接口的 loading 状态
    }
  },
  computed: {
    ...mapState([
      'region',
      'source',
      'gameName',
      'selectedPaymentInfo',
      'isApp',
      'paymentAccountInfo',
    ]),
    query() {
      const {
        params: { gameName = '' },
      } = this.$route
      return {
        ...this.$route.query,
        from: gameName || 'myWallet',
      }
    },
    accountBalance: {
      get() {
        // 从缓存中取钱包余额
        return (this.paymentAccountInfo && this.paymentAccountInfo.amount) || 0
      },
      set(val) {
        return val
      },
    },
    accountStatus() {
      // 支付账户状态：1正常 2冻结 3注销
      return (this.paymentAccountInfo && this.paymentAccountInfo.status) || 1
    },
    frozenScene() {
      // 冻结原因 1:密码输错次数过多 2:后台人工操作 3.发生拒付
      return (
        (this.paymentAccountInfo && this.paymentAccountInfo.frozenScene) || 0
      )
    },
    maxChannelPrice() {
      const { channelList = [] } = this
      let price = 0
      channelList.map((item) => {
        if (item.channelPrice * 1 > price) {
          price = item.channelPrice * 1
        }
      })
      return price
    },
    selectedPayment() {
      // 当前选中的支付方式
      if (!this.channelList) return {}
      for (let item of this.channelList) {
        if (item && item.active) {
          return item
        }
      }
      return {}
    },
    selectedSku() {
      if (!this.skuList) return {}
      return (
        this.skuList.filter(
          (item) => item.id + '' === this.activeSku + ''
        )[0] || {}
      )
    },
    readyToSubmit() {
      const {
        selectedPayment,
        isSelfDefinedSelected,
        cacheChannelDatas,
        skuId,
      } = this
      const { minPayPrice, maxPayPrice } = selectedPayment
      const inputPrice = this.removeFormat(this.digit)
      // 当前支付方式是否有缓存支付方式
      const cachedPaymentList = cacheChannelDatas.get(skuId + '')
      const currentSkuHasCachedChannels =
        cachedPaymentList && cachedPaymentList.length > 0
      if (
        !currentSkuHasCachedChannels ||
        !(selectedPayment && Object.keys(selectedPayment).length > 0) || // 未选中支付方式
        (isSelfDefinedSelected &&
          (!this.totalAmount ||
            isNaN(inputPrice) || // 防止只输入了小数分隔符
            inputPrice * 1 === 0 ||
            inputPrice < minPayPrice ||
            inputPrice > maxPayPrice))
      ) {
        return false
      } else {
        return true
      }
    },
    totalAmount() {
      return this.isSelfDefinedSelected ? this.digit : this.amount
    },
    isSelfDefinedSelected() {
      return (
        this.selfDefSkuData &&
        Object.keys(this.selfDefSkuData).length > 0 &&
        this.activeSku === 0
      )
    },
    errTip() {
      // 自定义金额输入错误格式提示
      const { minPayPrice, maxPayPrice } = this.selectedPayment
      const formattedMaxPrice = numberFormat(maxPayPrice, this.region)
      const formattedMinPrice = numberFormat(minPayPrice, this.region)
      const errMAP = {
        illegal_character: this.$t('wallet.illegal_character'), //'不允许输入除了小数分隔符以外的非数字字符'
        two_decimal_places_at_most: this.$t(
          'wallet.two_decimal_places_at_most'
        ),
        less_than_minPrice: this.$t('wallet.less_than_minPrice').replace(
          '{minPrice}',
          formattedMinPrice
        ),
        more_than_maxPrice: this.$t('wallet.more_than_maxPrice').replace(
          '{maxPrice}',
          formattedMaxPrice
        ),
        only_digits: this.$t('wallet.only_digits'),
        id_largest_supported_digits: this.$t(
          'wallet.id_largest_supported_digits'
        ),
        other_largest_supported_digits: this.$t(
          'wallet.other_largest_supported_digits'
        ),
        empty: '',
      }
      return errMAP[this.errType]
    },
  },
  created() {
    this.setInitSource()
  },
  beforeDestroy() {
    bus.$off('showNotice')
    bus.$off('account-risk')
  },
  methods: {
    ...mapMutations([
      'setCurrency',
      'setSource',
      'setPaymentAccountInfo',
      'setUserInfo',
    ]),
    ...mapActions(['getWalletBalance']),
    setInitSource() {
      let source = this.$route.query?.source || ''
      if (source && Array.isArray(source) && source.length) {
        source = source[source.length - 1]
      }

      if (!source || source === 'undefined' || source === '') {
        source = 'ns'
      }
      if (this.isApp && source && source.toLocaleLowerCase() !== 'iap') {
        source = 'inapp'
      }
      this.setSource(source)
    },
    login(data) {
      if (data.status === 1) {
        this.userInfo = data.userInfo
        this.getWalletBalance()
        this.checkPayPwSetOrNot()
      } else {
        Toast.fail(this.$t('common.login_again'), {
          duration: 2000,
        })
        setTimeout(this.backHome, 2000)
      }
      this.setUserInfo(this.userInfo || {})
    },
    async initPackage() {
      let skuList = (await this.getSkuDataList(gameName)) || []
      skuList.sort((a, b) => a.localTaxPrice - b.localTaxPrice) // 升序排列以便获取 0.01 （对应自定义金额）那一项
      skuList = skuList.map((item, index) => {
        item.id = index
        return item
      })
      const firstSku = skuList.slice(0, 1)[0]
      if (firstSku && firstSku.skuType * 1 === 2) {
        //1普通商品   2多数量商品
        this.selfDefSkuData = firstSku // 自定义金额对应的数据
        skuList = skuList.slice(1) // 其余为固定金额商品
        this.activeSku = skuList.length > 0 ? 1 : 0 // 确保初始化默认选中第一个套餐
      }
      // 充值使用的货币单位
      this.currency = skuList[0] && skuList[0].currency
      this.currencySymbol = skuList[0] && skuList[0].currencySymbol
      this.currencySymbol && this.setCurrency(this.currencySymbol)

      this.skuList = skuList
      this.skuId = this.getSkuId(skuList, this.selfDefSkuData)
      this.initChannel(this.skuId)
    },
    removeFormat(sNum) {
      // 输入的金额字符串经过格式化处理（具有正确的本地化格式）
      const thousandsSeparator = thous_separator[this.region]
      const decimalPointSep = decimal_point_separator[this.region]
      if (sNum.indexOf(decimalPointSep) > -1) {
        // 存在小数分隔符时则将其转换为一个特殊符号
        sNum = sNum.replace(decimalPointSep, '#')
      }
      return sNum.replace(thousandsSeparator, '').replace('#', '.')
    },
    getSkuId(skuList = [], selfDefSkuData) {
      if (skuList.length === 0 && selfDefSkuData) {
        // 只配置了自定义金额商品
        return selfDefSkuData.skuId
      } else {
        // 配置了固定金额商品，默认选中第一个，若有缓存则优先取缓存
        this.activeSku = 1
        const id = storage.get('wallet_currActiveSku')
        if (!isNaN(id * 1) && skuList.length >= id) {
          this.activeSku = id * 1
        }
        if (this.isSelfDefinedSelected) {
          // 选中自定义金额
          return selfDefSkuData.skuId
        } else {
          const data = skuList.filter(
            (item) => item.id + '' === this.activeSku + ''
          )
          return data.length > 0 ? data[0].skuId : id * 1
        }
      }
    },
    async initChannel(skuId) {
      let channelList = await this.getSkuOfChannelList(skuId)
      // Game Turbo 模式下，支付方式只取前 4 种
      if (this.displayTurbo) {
        channelList = channelList.map((item, index) => {
          item.display = true
          if (index === 0) {
            item.active = true
            this.selectedPaymentId = item.id
            this.amount = item.channelPrice
          }
          item.show = index <= 3
          return item
        })
      } else {
        // 初始化支付方式为可见
        channelList = channelList.map((item, index) => {
          item.display = true
          item.show = true
          item.active = false
          if (index === 0) {
            item.active = true
            this.selectedPaymentId = item.id
            this.amount = item.channelPrice
          }
          return item
        })
      }
      this.channelList = channelList
      this.restoreValuesFromStorage(channelList)
    },
    restoreValuesFromStorage(channelList) {
      // 恢复用户选择的支付方式
      const id = storage.get('wallet_currSelectedPaymentId')
      if (id && !isNaN(id * 1)) {
        const item = channelList.find((item) => `${item.id}` === `${id}`)
        if (item && (!this.displayTurbo || item.show)) {
          this.selectPayment(item)
        } else {
          this.selectPayment(channelList[0])
        }
      }
    },
    selectPayment(item = {}) {
      if (Object.keys(item).length === 0) {
        return
      }
      // 记录所选支付方式id
      this.selectedPaymentId = item.id
      this.amount = item.channelPrice
      storage.set('wallet_currSelectedPaymentId', item.id) // 缓存当前的 channel Id
      const { channelList } = this
      channelList.forEach((data, index) => {
        if (data.id === item.id) {
          channelList[index].active = true
        } else {
          channelList[index].active = false
        }
      })
      this.channelList = JSON.parse(JSON.stringify(channelList))
    },
    async getSkuDataList() {
      try {
        const skuList = await getSkuList({
          game: gameName,
          status: 1,
          country: this.region,
        })
        return !skuList || skuList.length === 0 ? [] : skuList
      } catch (e) {
        window.console.log('get sku error', e)
      }
    },
    // 获取当前套餐对应的支付通道
    async getSku2ChannelList(skuId) {
      if (this.isIAP) return
      if (skuId === 1) return
      try {
        return await getSku2Channel({
          skuId,
          game: gameName,
          status: 1,
          country: this.region,
          isRoute: true,
        })
      } catch (e) {
        window.console.log('get channel error', e)
      }
    },
    // 获取当前套餐对应的支付通道所有信息
    async getSkuOfChannelList(skuId) {
      let currentChannelList = []
      // 缓存处理
      const cacheData = this.cacheChannelDatas.get(skuId + '')
      if (cacheData && cacheData.length > 0) {
        currentChannelList = cacheData
      } else {
        // 如果正在加载，直接返回 false，防止重复请求
        if (
          this.loadingSkuChannels[skuId] &&
          this.loadingSkuChannels[skuId].isLoading
        ) {
          return false
        }
        this.loadingSkuChannels[skuId] = {
          isLoading: true,
        }
        const skuChannels = (await this.getSku2ChannelList(skuId)) || []
        this.cacheChannelDatas.set(skuId + '', skuChannels)
        this.loadingSkuChannels[skuId] = {
          isLoading: false,
        }
        if (this.skuId !== skuId) return false
        currentChannelList = skuChannels
      }
      return currentChannelList
    },
    async selectPackage(data, type) {
      if (!type) {
        this.activeSku = data.id
        this.digit = '' //选中固定金额时清空已输入的自定义金额
        this.errType = 'empty' // 若选中了固定金额则清除错误提示
      }
      this.skuId = data.skuId
      storage.set('wallet_currActiveSku', data.id) // 缓存当前的 activeSku

      let skuChannels = await this.getSkuOfChannelList(data.skuId)
      if (this.skuId !== data.skuId) return // 如果用户在请求期间切换了SKU，则忽略旧请求的结果，避免显示错误的支付通道
      if (skuChannels !== false) {
        this.initSkuChannels(skuChannels) //初始化sku关联的通道
      }
    },
    initSkuChannels(skuChannels) {
      let currentChannels = []
      if (skuChannels && Array.isArray(skuChannels) && skuChannels.length) {
        currentChannels = skuChannels.map((item, index) => {
          if (this.displayTurbo) {
            item.show = index <= 3
          } else {
            item.show = true
          }
          if (this.selectedPaymentId) {
            // 如果之前已经选中过支付方式，则仍然选中该支付方式
            item.active =
              item.id + '' === this.selectedPaymentId + '' && item.show
          } else {
            // 如果没有已经选中的支付方式，则默认选择第一种支付方式
            item.active = index === 0
          }
          if (item.active) {
            this.amount = item.channelPrice // 初始化待支付金额
            this.selectedPaymentId = item.id
            storage.set('wallet_currSelectedPaymentId', item.id)
          }
          return item
        })
      }

      this.channelList = currentChannels
      if (currentChannels && currentChannels.length > 0) {
        if (currentChannels.filter((channel) => channel.active).length === 0) {
          currentChannels[0].active = true
          this.amount = currentChannels[0].channelPrice // 初始化待支付金额
          this.selectedPaymentId = currentChannels[0].id
        }
      } else {
        this.amount = 0 // 没有支付方式时默认显示0
      }
    },
    getReturnUrl(type) {
      // 给钱包充值的返回地址
      const fix = setRouteBase() === '/' ? '' : setRouteBase()
      const { serverid = '' } = this.$route.query
      const { source = '', gameName } = this
      // 去除当前 url 可能携带的 orderNo
      let queryParams = { ...this.$route.query }
      delete queryParams.sf
      delete queryParams.nf
      if (!(type === 'createOrder' && this.region === 'br')) {
        queryParams = { ...queryParams, orderNo: '' }
      }
      queryParams = {
        ...queryParams,
        source,
        game: gameName,
        serverid,
        mode: this.displayTurbo ? 'gt' : 'default',
      }
      const queryString = jsontoString(deleteEmpty(queryParams))
      // 在游戏详情页时，返回详情页，钱包页面时，返回钱包结果页
      return `${window.location.origin}${fix}/${
        this.isMyWallet ? 'pay-result' : this.gameName
      }?${queryString}`
    },
    gotoPay(cb = () => {}) {
      if (
        !this.readyToSubmit ||
        (this.isCreatingOrder && !this.justInitiatedPw)
      ) {
        // 除了刚初始化钱包密码后可以继续下单流程，其它情况不允许（比如在下单流程中再次点击下单按钮）
        return
      }
      this.isCreatingOrder = true

      const { channelPrice, payMethod, payMethodName } = this.selectedPayment

      if (this.pwIsSet === 'error') {
        // 请求有问题或者接口返回异常
        this.isCreatingOrder = false
        return false
      } else if (this.pwIsSet === false) {
        // 接口正常返回：用户未设置密码，弹出密码绑定弹窗
        this.showPwSettingPopup = true
        return false
      }

      storage.set('wallet_currActiveSku', this.activeSku) // 缓存当前 sku 的 id
      // 点击支付 - 删除是否首次绑定密码
      storage.remove(firstCreatePassword)
      // 删除正在充值中的订单号
      storage.remove(walletPayingOrder)
      // 设置钱包正在充值中, 仅在详情页中设置
      !this.isMyWallet && storage.set(walletIsPaying, 'true')
      // 设置正在充值中的skuId
      !this.isMyWallet &&
        storage.set(
          `${walletPayingSkuId}-${this.gameName}`,
          this.selectedPaymentInfo.skuId
        )

      const payPrice = getPriceNum(this.digit, this.region) // 将小数点转换回人民币格式
      let goodsCount = 1,
        currSku = {}
      if (this.isSelfDefinedSelected) {
        currSku = this.selfDefSkuData
        goodsCount = div(payPrice, channelPrice)
      } else {
        currSku = this.skuList.find((item) => item.skuId === this.skuId)
      }

      const { skuId, skuName } = currSku
      const { source, userInfo = {}, region } = this
      const email =
        userInfo && userInfo.email
          ? userInfo.email
          : 'toplupeservice@aptostar.com'
      // 充值点击埋点
      trackClickGoPay({
        page: pageName,
        payment_name: payMethodName,
        amount: channelPrice,
        sku_id: skuId,
        quantity: goodsCount,
        currency: this.currency,
      })
      const returnUrl = this.getReturnUrl()
      const params = {
        uid: this.userInfo.kicoinId, // 针对钱包充值暂时写死的参数，服务端走 api 下单逻辑
        country: region,
        game: gameName,
        skuId,
        skuName,
        payMethod,
        payPrice: this.isSelfDefinedSelected ? payPrice : channelPrice,
        goodsCount,
        isRoute: true,
        source,
        email,
        returnUrl,
      }
      this.createOrder(params, cb)
    },
    async createOrder(params, cb = () => {}) {
      try {
        const res = await placeOrder(params)

        if (res) {
          const { url, orderNo = '' } = res || {}
          // 设置钱包正在充值中的订单号
          !this.isMyWallet && storage.set(walletPayingOrder, orderNo)
          if (url) {
            this.justInitiatedPw = false
            this.createdOrderFinish()
            const returnUrl = this.getReturnUrl('createOrder')
            let params = this.isMyWallet
              ? JSON.stringify({ finishWhenBack: true })
              : JSON.stringify({ finishWhenBack: true })
            if (this.region === 'br') {
              tryToNative({
                url: `${url}&return_url=${returnUrl}`,
                params,
              }).catch(() => jumpToPage(`${url}&return_url=${returnUrl}`))
            } else {
              tryToNative({
                url,
                params,
              }).catch(() => jumpToPage(url))
            }

            // app内且详情页，跳转支付后重置页面
            if (this.isApp && !this.isMyWallet) {
              this.isCreatingOrder = false
              cb && typeof cb === 'function' && cb()
            }
            // app内且钱包页，跳转支付后重置页面
            if (this.isApp && this.isMyWallet) {
              window.location.reload()
            }
          }
        }
      } catch (e) {
        this.isCreatingOrder = false
        // 只有 apiErrCode 为 '20002' 时在响应拦截器中被阻拦，因而在此单独判断
        const { code } = e
        if (String(code) === '20002') {
          Toast.fail(this.$t(`apiErrorTips.${code}`)) // 账户已冻结
        }
        if (['1207', '1208'].includes(String(code))) {
          bus.$emit('account-risk', { errCode: code })
        }
        if (['20015', '20016'].includes(String(code))) {
          // 24小时内充值频次或金额过高，弹窗提示
          bus.$emit('showNotice')
        }
      }
    },
    createdOrderFinish() {
      storage.set('autoRechargeWallet', 0)
    },
    async checkPayPwSetOrNot() {
      try {
        const data = await checkPasswordIsSet({
          userId: this.userInfo.kicoinId,
        })
        if (data) {
          this.pwIsSet = data.result
        }
        return Promise.resolve(data.result)
      } catch (e) {
        this.pwIsSet = 'error'
        return Promise.reject('error')
      }
    },
    // end
  },
}
